export enum PermissionEnum {
    CREATE_ORDER = 'order:create',
    UPDATE_ORDER = 'orders:update:all',
    DELETE_ORDER = 'orders:remove:user',
}
